import React from "react"
import Entity from "../../../entity"

const FormFieldSubmit = ({ domRef, fieldValue, dispatch, info, value, ...props }) => {
    const handleSubmit = () => {
        dispatch({
            type: "submit",
        })
    }

    return (
        <div ref={domRef} {...props}>
            <button className="button" onClick={handleSubmit}>
                {Entity.get(value, "label", info.language)}
            </button>
        </div>
    )
}
export default FormFieldSubmit
